import * as React from 'react'
import { REGEXP_ONLY_DIGITS } from 'input-otp'
import {
	InputOTP,
	InputOTPGroup,
	InputOTPSeparator,
	InputOTPSlot,
} from '../ui/input-otp'

interface IProps {
	name: string
	length?: number
	focusOnMount?: boolean
}

export default function AuthInputOtp({ name, length = 6, focusOnMount = false }: IProps) {
	const [value, setValue] = React.useState('')
	const submitRef = React.useRef<HTMLInputElement>(null)

	const half = Math.floor(length / 2)

	const onComplete = () => {
		submitRef.current?.click()
	}

	return (
		<div className="flex flex-col items-center gap-4">
			<InputOTP
				maxLength={length}
				value={value}
				onChange={setValue}
				onComplete={onComplete}
				pattern={REGEXP_ONLY_DIGITS}
				autoFocus={focusOnMount}
				containerClassName="justify-center"
			>
				<InputOTPGroup>
					{Array.from({ length: half }).map((_, index) => (
						<InputOTPSlot key={index} index={index} />
					))}
				</InputOTPGroup>
				<InputOTPSeparator />
				<InputOTPGroup>
					{Array.from({ length: length - half }).map((_, index) => (
						<InputOTPSlot key={half + index} index={half + index} />
					))}
				</InputOTPGroup>
			</InputOTP>

			<input name={name} type="hidden" value={value} readOnly={true} />
			<input ref={submitRef} type="submit" style={{ display: 'none' }} />
		</div>
	)
}
